import Link from "next/link";
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Text,
} from "@chakra-ui/react";
import { Scissors } from "lucide-react";
import { HEADER_NAV, PRIMARY_CTA_HREF, PRIMARY_CTA_LABEL } from "./homeContent";

type NavItem = { label: string; href: string };

type HomeHeaderProps = {
  nav?: NavItem[];
};

export function HomeHeader({ nav = HEADER_NAV }: HomeHeaderProps) {
  return (
    <Box
      as="header"
      borderBottom="1px"
      borderColor="barber.100"
      position="sticky"
      top="0"
      zIndex="50"
      bg="barber.900"
      backdropFilter="blur(8px)"
    >
      <Container maxW="container.xl" py={4}>
        <Flex justify="space-between" align="center" gap={4}>
          <Link href="/">
            <HStack spacing={2}>
              <Scissors size={24} color="#fba931" />
              <Text fontSize="xl" fontWeight="bold" color="white">
                Meu Barbeiro Pro
              </Text>
            </HStack>
          </Link>

          <HStack spacing={6} display={{ base: "none", lg: "flex" }}>
            {nav.map((item) => (
              <Link key={item.href} href={item.href}>
                <Text
                  fontSize="sm"
                  fontWeight="medium"
                  color="barber.100"
                  _hover={{ color: "orange.900" }}
                >
                  {item.label}
                </Text>
              </Link>
            ))}
          </HStack>

          <HStack spacing={3} flexShrink={0}>
            <Link href="/login">
              <Text
                fontSize="sm"
                fontWeight="medium"
                color="white"
                _hover={{ textDecoration: "underline" }}
                display={{ base: "none", sm: "block" }}
              >
                Entrar
              </Text>
            </Link>
            <Button
              as={Link}
              href={PRIMARY_CTA_HREF}
              bg="button.cta"
              color="black"
              size="sm"
              _hover={{ opacity: 0.85 }}
            >
              {PRIMARY_CTA_LABEL}
            </Button>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}
